<template>
    <div>
        <loading v-if="!loaded">
            Loading
        </loading>
        <hr>
        <template v-if="loaded">
            <div class="row text-left quick-order__row--head">
                <div class="col-md-2">
                Code
                </div>
                <div class="col-md-3">
                Description
                </div>
                <div class="col-md-2">
                Quantity
                </div>
                <div class="col-md-2">
                Price
                </div>
                <div class="col-md-2 text-right">
                Total
                </div>
            </div>

            <div class="row text-left quick-order__row" v-for="(line, index) in lines" :key="index">
                <div class="col-sm-6 col-md-2">
                    <div class="form-group">
                        <input type="text" class="form-control" placeholder="e.g. 1850800" v-model="line.code" @keyup="getProduct(line)">
                        <p class="text-info" v-if="line.searching">
                            <i class="fa fa-refresh fa-spin"></i>&nbsp; Finding product
                        </p>
                        <p class="text-danger" v-if="line.error">
                            {{ line.error }}
                        </p>
                        <small class="text-info" v-if="alreadyInBasket(line)">
                            This product is already in your basket and will be overwritten when you submit this form
                        </small>

                        <small class="text-info" v-if="alreadyChosen(line.code, index)">
                            You have already added this product.
                        </small>
                    </div>
                </div>

                <div class="col-sm-6 col-md-3">
                    <span v-if="line.product"><small>{{ line.product.name }}</small></span>
                </div>
                <div class="clearfix visible-sm-block">
                </div>
                <div class="col-sm-4 col-md-2">
                    <div class="form-group">
                        <input type="number" class="form-control" v-model="line.quantity">
                    </div>
                </div>
                <div class="col-sm-4 col-md-2">
                    <div class="product-price basket-row__price" v-if="line.product">
                        <product-price :price="variantPrice(line).amount" :tax="variantPrice(line).tax"></product-price>
                    </div>
                </div>
                <div class="col-sm-4 col-md-2 text-right">
                    <div class="product-price basket-row__price basket-row__price--line-price" v-if="line.product">
                        <product-price :price="variantPrice(line).amount * (line.quantity ? line.quantity : 1)" :tax="variantPrice(line).tax * line.quantity"></product-price>
                    </div>
                </div>
            </div>
            <hr>
            <div class="row">
                <div class="col-sm-6 text-left">
                <button type="button" class="btn btn-sm btn-blue" @click="addLines(5)">Add 5 more lines</button>
                <!-- Adds 5 more lines to the order form -->
                </div>
                <div class="col-sm-6 text-right">
                <button type="submit" class="btn btn-green" @click="process">Add Items to Basket</button>
                </div>
            </div>
        </template>
    </div>
</template>

<script>
    import Loading from '../Elements/Loading.vue';
    import Product from "../../Services/Product.js";
    import Variant from '../../Services/Variant.js';
    import ProductPrice from '../Product/ProductPrice.vue';
    import Basket from '../../Services/Basket.js';
    import Notification from '../../Services/Notification.js';

    export default {
        components: {
            Loading,
            ProductPrice
        },
        mounted() {
            this.loaded = true;
            this.addLines(this.initial);
        },
        props: {
            initial: {
                type: Number,
                default: 5
            }
        },
        data() {
            return {
                loaded: false,
                processing: false,
                processed: false,
                lines: []
            }
        },
        computed: {
            mappedLines() {

                let items = [];

                this.lines.forEach(line => {
                    if (line.product) {
                        items.push({
                            id: line.product.variants.data[0].id,
                            quantity: line.quantity
                        });
                    }
                });

                return items;
            }
        },
        methods: {
            /**
             * Searches for the product via the API
             */
            getProduct: _.debounce(line => {
                line.searching = true;
                line.error = false;

                if (!line.code) {
                    line.product = null;
                    line.searching = false;
                    return;
                }

                Product.getBySku(line.code).then(response => {
                    line.product = response.data;
                    line.searching = false;
                }).catch(error => {
                    line.searching = false;
                    line.error = "There was a problem finding the product";
                });

            }, 500),
            /**
             * Adds a number of lines to the quick order
             */
            addLines(qty) {
                for (let index = 0; index < qty; index++) {
                    this.addLine();
                }
            },
            /**
             * Adds a single line to the quick order
             */
            addLine() {
                this.lines.push({
                    "quantity": 1,
                    "product": null,
                    "searching": false,
                    "error": false,
                    "code": ""
                });
            },
            /**
             * Gets the variant price for the line
             */
            variantPrice(line) {
                console.log(line.product)
                const variant = line.product.variants.data[0],
                        tier = Variant.currentTier(variant.tiers.data, line.quantity);

                if (tier) {
                    return {
                        amount: tier.price / variant.unit_qty,
                        tax: tier.tax / variant.unit_qty
                    }
                }
                return {
                    amount: variant.unit_price,
                    tax: variant.unit_tax
                };
            },

            /**
             * Determine if a variant already exists in the basket.
             */
            alreadyInBasket(line) {
                const basket = Basket.getBasket();
                return _.find(basket.lines, item => {
                    return line.code == item.variant.sku;
                });
            },

            /**
             * Determine if a variant is already in the list
             */
            alreadyChosen(code, marker) {
                if (!code) {
                    return false;
                }
                return _.find(this.lines, (item, index) => {
                    return (index != marker) && (code == item.code);
                });
            },
            reset() {
                this.lines = [];
                this.addLines(this.initial);
            },
            process() {
                _.each(this.lines, line => {
                    line.error = null;
                });

                Basket.mergeLines(this.mappedLines).then(response => {
                    Notification.ring('Items added to basket', 'success');
                    this.reset();
                }).catch(error => {
                    let errors = error.response.data;

                    _.each(errors, (error, field) => {
                        let index = field.replace('variants.', '');
                        this.lines[index].error = error[0];
                    });
                });
            }
        }
    }
</script>

<style scoped>

</style>


// WEBPACK FOOTER //
// resources/assets/js/Components/Basket/QuickOrder.vue